import React, { useState, useEffect } from "react";
import { getOtp, ValidateOtp, ChangePassword } from "../services/Auth";
import { showSnackbar } from "./snackbar";

const ForgotPasswordModal = ({ onClose }) => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(0);
  const [otpVerified, setOtpVerified] = useState(false);
  const [userid, setUserid] = useState(null);

//   const userId=localStorage.setItem("userId");

  /* ---------------- TIMER ---------------- */
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  /* ---------------- VALIDATIONS ---------------- */
  const validateMobile = () => /^[0-9]{10}$/.test(mobile);
  const validateOtp = () => /^[0-9]{6}$/.test(otp);

  /* ---------------- STEP 1: SEND OTP ---------------- */
  const sendOtp = async () => {
    if (!validateMobile()) {
      showSnackbar("error", "Enter valid 10-digit mobile");
      return;
    }

   try {
  const response = await getOtp({ mobile, type: "forget" });

  if (response.data.stats === "done") {
    showSnackbar("success", "OTP sent");
    setTimer(5 * 60);
    setStep(2);
  } else {
    showSnackbar("error", response.data.stats || "Mobile number not registered");
  }
} catch (error) {
  showSnackbar(
    "error",
    error.response?.data?.message || "Failed to send OTP"
  );
}
  }
  /* ---------------- STEP 2: VERIFY OTP ---------------- */
  const verifyOtp = async () => {
    if (!validateOtp()) {
      showSnackbar("error", "Invalid OTP");
      return;
    }

    try {
      const res = await ValidateOtp({ mobile, otp,});
      setUserid(res.data.userid || mobile);
      setOtpVerified(true);
      setStep(3);
      showSnackbar("success", "OTP verified");
    } catch {
      showSnackbar("error", "OTP verification failed");
    }
  };

  /* ---------------- STEP 3: CHANGE PASSWORD ---------------- */
  const changePassword = async () => {
    if (!password || !confirmPassword) {
      showSnackbar("error", "Fill all fields");
      return;
    }

    if (password !== confirmPassword) {
      showSnackbar("error", "Passwords do not match");
      return;
    }

    try {
      await ChangePassword({
        userid:userid,
        password,
        password2: confirmPassword,
        type: "forget",
      });

      showSnackbar("success", "Password changed successfully");
      onClose();
    } catch {
      showSnackbar("error", "Password change failed");
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <div style={overlay}>
      <div style={modal}>
        <button style={closeBtn} onClick={onClose}>✕</button>

        <h2>Forgot Password</h2>

        {/* STEP 1 */}
        {step === 1 && (
          <>
            <input
              placeholder="Mobile Number"
              value={mobile}
              onChange={(e) =>
                setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
              }
              style={input}
            />
            <button onClick={sendOtp} style={button}>Send OTP</button>
          </>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <>
            <input
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
              }
              style={input}
            />
            <p>
              Time Left: {minutes}:{seconds.toString().padStart(2, "0")}
            </p>
            <button onClick={verifyOtp} style={button}>Verify OTP</button>
          </>
        )}

        {/* STEP 3 */}
        {step === 3 && otpVerified && (
          <>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={input}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={input}
            />
            <button onClick={changePassword} style={button}>
              Change Password
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modal = {
  background: "#fff",
  padding: 30,
  width: 380,
  borderRadius: 12,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: 15,
};

const input = {
  padding: 12,
  fontSize: 15,
  borderRadius: 6,
  border: "1px solid #ccc",
};

const button = {
  padding: 12,
  background: "#005487",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

const closeBtn = {
  position: "absolute",
  top: 10,
  right: 12,
  background: "none",
  border: "none",
  fontSize: 18,
  cursor: "pointer",
};
